import {AllCriteria, Criteria} from "@/types/Criteria.ts";
import {activeLocale, getLocalizedFieldName} from "@/utils/translation-helper.ts";

interface PathToCriterionName {
    [key: string]: string;
}

// the values match the keys in translation.json "criteria"
export const pathToCriterionName: PathToCriterionName = {
    "languages": "language",
    "disciplines": "discipline",
    "research-expertises": "researchExpertise",
    "primary-affiliations": "careerFocus",
    "experiences": "experience",
    "races": "races",
    "socioeconomic-disadvantages": "socioeconomicDisadvantages",
    "indigeneities": "indigeneities",
    "disabilities": "disabilities",
    "genders": "gender",
    "sexual-orientations": "sexualOrientation",
};

type KeyValueMappingType = {
    [key: string]: {
        label: string;
        key?: string;
        bool?: boolean;
        broad?: boolean;
        hasNarrow?: boolean,
        narrowKeys?: string[];
    };
}

export const keyValueMapping: KeyValueMappingType = {
    careerFocusId: {label: "careerFocus", key: "CareerFocus", broad: true},
    experienceId: {label: "experience", key: "Experience", broad: true},
    list_disciplines: {label: "discipline", key: "Discipline", broad: true},
    list_researchExpertises: {label: "researchExpertise", key: "ResearchExpertise", broad: true},
    hasSocioeconomicDisadvantage: {
        label: "hasSocioeconomicDisadvantage",
        bool: true,
        broad: true,
        hasNarrow: true,
        narrowKeys: ["socioeconomicDisadvantages"]
    },
    isRacialized: {label: "isRacialized", bool: true, broad: true, hasNarrow: true, narrowKeys: ["races"]},
    isIndigenous: {label: "isIndigenous", bool: true, broad: true, hasNarrow: true, narrowKeys: ["indigeneities"]},
    hasDisability: {label: "hasDisability", bool: true, broad: true, hasNarrow: true, narrowKeys: ["disabilities"]},
    isQueer: {
        label: "isQueer",
        bool: true,
        broad: true,
        hasNarrow: true,
        narrowKeys: ["genderId", "sexualOrientationId"]
    },
    isMale: {label: "isMale", bool: true, broad: true},
    isFemale: {label: "isFemale", bool: true, broad: true},
    socioeconomicDisadvantages: {label: "socioeconomicDisadvantages", key: "SocioeconomicDisadvantage"},
    races: {label: "races", key: "Race"},
    indigeneities: {label: "indigeneities", key: "Indigeneity"},
    disabilities: {label: "disabilities", key: "Disability"},
    genderId: {label: "gender", key: "Gender"},
    sexualOrientationId: {label: "sexualOrientation", key: "SexualOrientation"},
}

export const getCriteriaValue = (criteria: AllCriteria | undefined, criterion: string, value: any) => {
    const keyMapping = keyValueMapping[criterion];
    if (!keyMapping) {
        return value != null ? String(value) : "N/A";
    }

    if (keyMapping.bool) {
        if (value === 'true') {
            return activeLocale() === 'en' ? 'Yes' : 'Oui';
        } else {
            return activeLocale() === 'en' ? 'No' : 'Non';
        }
    }

    if (criteria && keyMapping.key) {
        const item = criteria[keyMapping.key as keyof AllCriteria].find(item => item.id === parseInt(value, 10));
        return item ? item[getLocalizedFieldName("name") as keyof Criteria] : '';
    }

    return "N/A";
}
